import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=a668f198&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "../../templateAssests/css/listing.css?vue&type=style&index=0&id=a668f198&scoped=true&lang=css&"
import style1 from "../../templateAssests/css/detail-page.css?vue&type=style&index=1&id=a668f198&scoped=true&lang=css&"
import style2 from "./orderDetails.vue?vue&type=style&index=2&id=a668f198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a668f198",
  null
  
)

export default component.exports